import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuth } from 'src/hooks/useAuth';

import Spinner from 'src/components/common/designSystem/Spinner';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import LoginPanel from 'src/components/Login/LoginPanel';
import BackArrowHeader from 'src/components/Header/BackArrowHeader';
import BlankLayout from 'src/layouts/BlankLayout';

function Login() {
  const { setIsLoggedIn } = useAuth();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const onboardingCode = searchParams.get('onboardingCode');

  useEffect(() => {
    if (onboardingCode) {
      // Generated link from onboarding for first child
      FirebaseAuthentication.signInWithCustomToken({
        token: onboardingCode,
      })
        .then(async result => {
          if (result.user) {
            navigate('/onboarding/child/objective');
            return;
          }
          setSearchParams({});
        })
        .catch(() => {
          // If any error, the code must be wrong or expired, so remove loading state
          setSearchParams({});
        });
    }
  }, [navigate, onboardingCode, setIsLoggedIn, setSearchParams]);

  if (onboardingCode) {
    return <Spinner className="w-full h-full" size="large" />;
  }

  return (
    <BlankLayout>
      <BackArrowHeader />
      <LoginPanel className="flex-1 bg-transparent" allowFamilyCode />
    </BlankLayout>
  );
}

export default Login;
